import styled from 'styled-components';
import warningPregnancy from 'assets/img/warningPregnancy.svg';

const TriangleSvg = ({color}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'>
      <path
        d='M0.835938 17.5003L10.0026 1.66699L19.1693 17.5003H0.835938ZM3.71094 15.8337H16.2943L10.0026 5.00033L3.71094 15.8337ZM10.0026 15.0003C10.2387 15.0003 10.4366 14.9205 10.5964 14.7607C10.7561 14.601 10.8359 14.4031 10.8359 14.167C10.8359 13.9309 10.7561 13.733 10.5964 13.5732C10.4366 13.4135 10.2387 13.3337 10.0026 13.3337C9.76649 13.3337 9.56858 13.4135 9.40885 13.5732C9.24913 13.733 9.16927 13.9309 9.16927 14.167C9.16927 14.4031 9.24913 14.601 9.40885 14.7607C9.56858 14.9205 9.76649 15.0003 10.0026 15.0003ZM9.16927 12.5003H10.8359V8.33366H9.16927V12.5003Z'
        fill={color}
      />
    </svg>
  );
};

const AlertText = ({value}) => {
  const isPregnant = (
    <Wrapper>
      <img className={'icon'} src={warningPregnancy} />
      <span className={'reportText'}>
        The following report is generated based on target ranges for
        pregnancy.If the patient
        <span className={'bold'}> is not pregnant </span>
        please <span className={'bold'}>uncheck </span>the related box in the
        patient's profile.
      </span>
    </Wrapper>
  );

  const wrongEstimate = (
    <Wrapper>
      <div style={{position: 'absolute'}}>
        <TriangleSvg color='#753CBE' />
      </div>
      <span className={'reportText'}>
        Please Note: The following report has been estimated using smart
        FREESENS algorithms.
      </span>
    </Wrapper>
  );

  const suspictionEstimate = (
    <Wrapper>
      <div className='icon'>
        <TriangleSvg className={'icon'} color='#D81D5D' />
      </div>
      <span className={'reportText'} style={{color: '#D81D5D'}}>
        Please Note: Due to inaccurate glucometer time settings, the following
        report is based on estimations.
      </span>
    </Wrapper>
  );

  const texts = {
    isPregnant,
    wrongEstimate,
    suspictionEstimate,
  };

  return texts[value];
};

export default AlertText;

const Wrapper = styled.div`
  direction: ltr;
  .reportText {
    font-size: 12px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0;
    text-align: left;
    color: #6f4d9f;
    padding-left: 28px;
  }
  .bold {
    font-weight: 700 !important;
  }
  .icon {
    position: absolute;
  }
`;
